module.exports = __webpack_public_path__ + "static/media/select-delivery-ac-icon.1e911537.png";